module.exports = function() {
  return new Worker(__webpack_public_path__ + "1566458adcdf02b68ac2.worker.js");
};